// extracted by mini-css-extract-plugin
export default {"description":"InviteParkers_description__qzoJK"};